import * as graphql from 'generated/graphql';

import { Button, QuillInput } from '@treams/treams-ui';
import useProtectedValue from 'conversations/conversation/hooks/useProtectedValue';
import Delta from 'quill-delta';
import { ConversationItemWithComments } from 'generated/graphql';
import SaveStatus from '../layout/SaveStatus';
import { Group } from '@mantine/core';

export default function NewCommentEditor({
	item,
	onNewComment,
	onDiscard,
}: {
	item: ConversationItemWithComments;
	onNewComment: () => void;
	onDiscard?: () => void;
}) {
	const [{ value, dirty, changed }, { setValue, setDirty }] = useProtectedValue(new Delta());

	const [createCommentForConversationItemMutation, { loading: saving }] =
		graphql.useCreateCommentForConversationItemMutation();

	const handleChange = async (value: Delta) => {
		setValue(value);
		setDirty(true);
	};

	const handleSave = async () => {
		await createCommentForConversationItemMutation({
			variables: {
				conversationItemID: item.conversationItemID,
				content: value,
			},
			update(cache, { data }) {
				if (data?.createCommentForConversationItem) {
					cache.modify({
						id: cache.identify(item),
						fields: {
							comments(existingComments = []) {
								const newCommentRef = cache.writeFragment({
									data: data.createCommentForConversationItem,
									fragment: graphql.CommentFragmentDoc,
								});

								return [...existingComments, newCommentRef];
							},
						},
					});
				}
			},
		});

		onNewComment();
	};

	return (
		<>
			<QuillInput debounce={false} onChange={handleChange} value={value} />
			<Group justify="flex-end" mt="xs" gap="4px">
				<SaveStatus dirty={dirty} changed={changed} saving={saving} />
				{!saving && (
					<Button
						type="transparent"
						disabled={saving || !changed}
						// @TODO: Translate
						title="Annuleren"
						onClick={onDiscard}
						small
					/>
				)}
				<Button
					small
					onClick={handleSave}
					disabled={saving}
					// @TODO: Translate
					title="Opslaan"
				/>
			</Group>
		</>
	);
}
